import { Component } from '@verndale/core';

class BoatDetailsModal extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      close: this.el.querySelector('.close'),
      showAllBtn: document.querySelector('.show-all-specs-btn'),
      showMoreBtn: document.querySelector('.overview-block__show-more-btn'),
    };
  }

  addListeners() {
    this.dom.close.addEventListener('click', this.handleClose.bind(this));
    this.dom.showAllBtn.addEventListener('click', this.handleShowAll.bind(this));
    this.dom.showMoreBtn.addEventListener('click', this.handleShowAll.bind(this));
    document.addEventListener('keydown', this.handleEscClose.bind(this));
    this.dom.el.addEventListener('click', this.handleClickOutside.bind(this));
  }

  handleClickOutside(e) {
    if (e.target === e.currentTarget) {
      this.el.close();
      document.body.style.overflow = 'auto';
    }
  }

  handleShowAll() {
    this.el.showModal();
    document.body.style.overflow = 'hidden';
  }

  handleClose() {
    this.el.close();
    document.body.style.overflow = 'auto';
  }

  handleEscClose(e) {
    if (e.key === 'Escape') {
      this.el.close();
      document.body.style.overflow = 'auto';
    }
  }
}

export default BoatDetailsModal;
